import { useSyncExternalStore } from "react"
import type { Market } from "@/lib/useMarket"

// Which product the quick view panel shows; null while it is closed. Kept
// outside React so any page row or the top bar search can open the panel
// without passing anything down: AppLayout mounts the one panel.
let openExternalId: string | null = null
// The market the opener asked for (a market section on an all-markets page);
// null leaves the choice to the panel.
let openMarket: Market | null = null
const listeners = new Set<() => void>()

function emit() {
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function openProductQuickView(externalId: string, market: Market | null = null) {
  openExternalId = externalId
  openMarket = market
  emit()
}

export function closeProductQuickView() {
  if (openExternalId === null) return
  openExternalId = null
  openMarket = null
  emit()
}

export function getProductQuickViewId(): string | null {
  return openExternalId
}

export function useProductQuickViewId(): string | null {
  return useSyncExternalStore(subscribe, getProductQuickViewId, () => null)
}

function getProductQuickViewMarket(): Market | null {
  return openMarket
}

export function useProductQuickViewMarket(): Market | null {
  return useSyncExternalStore(subscribe, getProductQuickViewMarket, () => null)
}
